<template lang="pug">
#banner-noticias(v-loading='carregando', style='height: 100%')
    h3 {{ $t('mensagens.home.noticias.titulo') }}
    .lyra__cartao
        el-carousel(height='170px', arrow='never', :interval='7000')
            el-carousel-item(
                v-for='(noticia, index) in noticias',
                :key='index',
                :style='`background-image: linear-gradient(to left, transparent, var(--primary)), url(${noticia.imagem})`'
            )
                a.banner-noticias__informacoes(
                    :href='noticia.link',
                    target='_blank'
                )
                    h2 {{ noticia.titulo }}
                    h3 {{ noticia.descricao }}
                    p.banner-noticias__data {{ noticia.dataCadastroFormatada }}
</template>

<script>
import NoticiasService from '@/services/NoticiasService';
import { mapState } from 'vuex';

export default {
    name: 'BannerNoticias',

    mounted() {
        this.buscarNoticias();
    },

    data() {
        return {
            noticias: [],
            carregando: false
        };
    },

    computed: {
        ...mapState(['usuarioLogado'])
    },

    methods: {
        async buscarNoticias() {
            const noticiaVazia = {
                titulo: this.$t('mensagens.home.noticias.naoHaNoticias'),
                descricao: '',
                link: '',
                ativo: true,
                dataCadastroFormatada: '',
                imagem: ''
            };

            if (this.usuarioLogado.ambienteLogado !== 'BR') {
                this.noticias = [noticiaVazia];
                return;
            }

            try {
                this.carregando = true;
                const { data } = await NoticiasService.buscarNoticias();

                this.noticias = data.length ? data : [noticiaVazia];
            } catch (e) {
                this.$notify.error({
                    message: this.$t('mensagens.home.noticias.erro')
                });
            } finally {
                this.carregando = false;
            }
        }
    },

    watch: {
        '$i18n._vm.locale': function () {
            this.buscarNoticias();
        }
    }
};
</script>

<style lang="scss" scoped>
.lyra__cartao {
    height: 100%;
    overflow: hidden;
}

.banner-noticias__informacoes {
    cursor: pointer;
}
</style>

<style lang="scss">
#banner-noticias {
    .el-carousel__item {
        background-repeat: no-repeat !important;
        background-size: cover !important;
        background-position: center !important;
        color: var(--white) !important;
        padding: 20px 25px;

        h2 {
            font-size: 30px;
            font-weight: 500;
            margin-bottom: 6px;
            margin-top: -9px !important;
            word-break: break-word;
            text-align: left;
        }

        h3 {
            font-weight: 500;
            margin-bottom: 15px;
            text-align: left;
        }

        .banner-noticias__data {
            position: absolute;
            bottom: -17px !important;
            left: 3px;
        }
    }
    & > h3 {
        font-weight: 700;
        margin-bottom: 5px;
    }

    .el-carousel__button {
        width: 10px !important;
        height: 10px !important;
        border-radius: 5px !important;
        margin: 0px 0px 0px 1px;
    }

    .is-active > .el-carousel__button {
        background-color: var(--secondary) !important;
    }

    .el-carousel__indicators--horizontal {
        bottom: 5px !important;
        left: 20px !important;
        -webkit-transform: none !important;
        transform: none !important;
    }

    a {
        color: var(--white) !important;
        text-decoration: none !important;
    }
}
</style>
